import { Directive, inject, TemplateRef } from '@angular/core';

/**
 * Defines a header cell of column.
 */
@Directive({
  selector: '[fbSimpleTableHeaderCellDef]',
})
export class SimpleTableHeaderCellDef {
  /**
   * Template for the header cell.
   */
  public readonly template = inject(TemplateRef);
}
